<template>
  <section id="response_message" class="py-8 px-4">
    <div class="pb-8">
      <h2 class="text-center speedee-bd text-3xl pb-4">
        Abmeldung von Family PLUS:
      </h2>
    </div>
    <div
      class="md:w-9/12 m-auto shadow-mcd-form rounded-mcd-lg px-4 md:px-12 lg:px-24 xl:px-48"
    >
      <!-- preloader START -->
      <Preloader v-if="submitStatus == 'LOADING'" />
      <!-- preloader END -->
      <UnsubscribeSuccessMessage v-if="submitStatus == 'OK'" />
      <!-- Success Message END -->
      <div v-if="submitStatus != 'OK'" class="py-16">
        <p>Ich möchte mich abmelden von:</p>
        <!-- NL START -->
        <div class="pt-8">
          <!-- Check box NL START -->
          <label class="flex justify-start items-start pb-4">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[nl ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray']"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model="nl"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">Family PLUS Newsletter</div>
          </label>
        </div>
        <!-- Check box NL END -->
        <!-- NL END -->
        <!-- TIPI START -->
        <div class="pt-8">
          <!-- Check box TIPI START -->
          <label class="flex justify-start items-start pb-2">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[tipi ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray']"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model="tipi"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">Tipi Familienmagazin</div>
          </label>
          <!-- Check box TIPI END -->
        </div>
        <!-- TIPI END -->
        <!-- GB START -->
        <div class="pt-8">
          <!-- Check box GB START -->
          <label class="flex justify-start items-start pb-2">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[gb ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray']"
            >
              <input
                type="checkbox"
                name="gb"
                class="opacity-0 absolute"
                v-model="gb"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">Geburtstagsüberraschung</div>
          </label>
          <!-- Check box GB END -->
        </div>
        <!-- GB END -->
        <!-- E-Mail START -->
        <div class="pt-8">
          <input
            class="w-full bg-white h-14 px-5 rounded focus:outline-none"
            :class="[
              submitStatus == 'ERROR' && !$v.email.email ? 'error' : '',
              submitStatus == 'ERROR' && !$v.email.required ? 'error' : '',
            ]"
            type="email"
            name="email"
            placeholder="E-Mail"
            v-model.trim="$v.email.$model"
          />
          <div class="text-red-600 text-sm pt-2">
            <p v-if="submitStatus == 'ERROR' && !$v.email.required">
              Erforderlich
            </p>
            <p v-if="submitStatus == 'ERROR' && !$v.email.email">
              Eine gültige E-Mail-Adresse ist erforderlich.
            </p>
          </div>
        </div>
        <!-- E-Mail END -->
        <!-- reCaptcha Start -->
        <!-- reCaptcha Start -->
        <div class="flex justify-center">
          <div class="relative">
            <vue-recaptcha
              class="mt-4 cyb-recaptcha"
              sitekey="6Lcg8FsaAAAAAIT8aqLptBxRl2c7kmZFjw2qQYYB"
              :loadRecaptchaScript="true"
              ref="recaptcha"
              @verify="onVerify"
              @expired="onExpired"
            ></vue-recaptcha>
            <div class="text-red-600 text-sm pt-2">
              <p v-if="submitStatus == 'ERROR' && !$v.reCpatcha.required">
                Erforderlich
              </p>
            </div>
          </div>
        </div>
        <!-- reCaptcha End -->
        <div class="flex justify-center md:pt-12">
          <button
            class="bg-mcdonalds-yellow rounded-full py-4 px-12 md:px-16 text-black text-xl speedee-bd mt-4 focus:outline-none"
            @click="validateForm()"
          >
            Abmelden
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { reCaptchaMixin, refererApiMixin, scrollToIdMixin } from "../mixins";
import VueRecaptcha from "vue-recaptcha";
import Preloader from "./Preloader";
import UnsubscribeSuccessMessage from "./Messages/UnsubscribeSuccess.vue";
import { required, email } from "vuelidate/lib/validators";
export default {
  components: {
    Preloader,
    UnsubscribeSuccessMessage,
    VueRecaptcha,
  },
  data() {
    return {
      submitStatus: null,
      reCpatcha: "",
      target: null,
      web: false,
      mob: false,
      app: false,
      email: "",
      nl: false,
      tipi: false,
      gb: false,
    };
  },
  validations: {
    reCpatcha: {
      required,
    },
    email: {
      required,
      email,
    },
  },
  mixins: [reCaptchaMixin, refererApiMixin, scrollToIdMixin],
  methods: {
    // method to validate child components
    async validateForm() {
      // run vuelidate and check if there some errors
      this.$v.$touch();

      let formData = new FormData();

      // create a json object from values to send to API
      let data = {
        email: this.email,
        nl: this.nl,
        tipi: this.tipi,
        gb: this.gb,
      };

      formData.append("data", JSON.stringify(data));
      formData.append("g-recaptcha-response", this.reCpatcha);

      // if validation is false
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        if (this.gb || this.tipi || this.nl) {
          try {
            // send API request to back end
            const registerUser = await this.sendDataToApi(formData);
            this.submitStatus = "OK";
            this.scrollToId();
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$swal({
            icon: "error",
            title:
              "Hoppla, du hast kein Angebot ausgewählt. Versuch‘s nochmal!",
          });
        }
      }
    },
    async sendDataToApi(formData) {
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=unregister",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            this.submitStatus = "OK";
            this.$refs.recaptcha.reset();
          }
          // catch the errors
        )
        .catch(function(error) {
          console.log(error);
        });
    },
  },
  mounted() {
    // on load check if url params are set and set the in a variable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // get paramaters by name
    this.email = urlParams.get("nlabmeldung");
    const from = urlParams.get("from");
    // call the values from parameters and set them in variables
    if (from == "app") {
      this.app = true;
    } else {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.mob = true;
      } else {
        this.web = true;
      }
    }

    if (urlParams.get("nlabmeldung")) {
      this.target = "nlabmeldung";
      this.nl = true;
    }
    // call the function to set referer values
    this.sendRefererToApi();
  },
};
</script>
